export default "__VITE_ASSET__CD0hlE6o__";